import { useIntl } from "react-intl";
import { Avatar } from "primereact/avatar";
import { Message } from "primereact/message";
import * as GlobalHelper from "../../../helpers/GlobalHelper";
import * as Displayhelper from "../../../helpers/DisplayHelper";
import MoreActions from "../moreActions";
import intl from "../../../i18n/intl";
import dayjs from "dayjs";

const customIntl = intl();

export const Tags = (data) => {
  return data?.tags?.join(", ") || "-";
};

export const DateOnly = (key) => (data) => {
  return (data[key] && dayjs(data[key]).format("DD MMM YYYY")) || "-";
};

export const NameAndEmail =
  (nameKey = "name", emailKey = "email") =>
  (data) => {
    return (
      <div className="flex gap-2">
        <Avatar
          label={Displayhelper.getUserShortName(data?.[nameKey])}
          size="small"
          shape="circle"
          className="edexlms-header-profile-avatar"
        />
        <div className="flex flex-column gap-1">
          <div className="text-blue-900">{data?.[nameKey]}</div>
          <div className="text-secondary">{data?.[emailKey]}</div>
        </div>
      </div>
    );
  };

export const TypeAndContentType = (data) => {
  return (
    <div className="flex flex-column gap-2">
      <div>{data?.type}</div>
      {(data?.type === "Scorm" && data?.contentType && (
        <div className="text-muted text-sm">({data?.contentType})</div>
      )) ||
        null}
    </div>
  );
};

export const FullNameAndEmail =
  (firstNameKey = "firstName", lastNameKey = "lastName", emailKey = "email") =>
  (data) => {
    return (
      <div className="flex gap-2">
        <Avatar
          label={Displayhelper.getUserShortName(
            `${data?.[firstNameKey]}${
              data?.[lastNameKey] ? ` ${data?.[lastNameKey]}` : ""
            }`
          )}
          size="small"
          shape="circle"
          className="edexlms-header-profile-avatar"
        />
        <div className="flex flex-column gap-1">
          <div className="text-blue-900">{`${data?.[firstNameKey]}${
            data?.[lastNameKey] ? ` ${data?.[lastNameKey]}` : ""
          }`}</div>
          <div className="text-secondary">{data?.[emailKey]}</div>
        </div>
      </div>
    );
  };

export const Text =
  (key, i18n = false) =>
  (data) => {
    return i18n ? customIntl.formatMessage({ id: data[key] }) : data[key];
  };

export const NameAndLogo =
  (nameKey = "name", logoKey = "logo") =>
  (data) => {
    const url = GlobalHelper.AddQueryParam(
      `${new URL(data?.[logoKey], process.env.REACT_APP_URL).toString()}`,
      "v",
      process.env.REACT_APP_VERSION
    );

    return (
      <div className="flex flex-column gap-2">
        <img
          src={url.updatedUrl}
          className="edexlms-enterprise-list-logo"
          alt={data?.[nameKey]}
        />
        <div>{data?.[nameKey]}</div>
      </div>
    );
  };

export const Status = (data) => {
  const intl = useIntl();
  const status = data?.isActive ? "active" : "inactive";
  return (
    <Message
      severity={data?.isActive ? "success" : "error"}
      text={intl.formatMessage({ id: status })}
      icon={""}
    />
  );
};

export const BooleanText = (key) => (data) => {
  return data[key] ? "Yes" : "No";
};

export const DateTime = (key) => (data) => {
  return data[key] ? dayjs(data[key]).format("DD MMM YYYY hh:mm a") : "-";
};

export const CreatedBy = (data) => {
  let name = data?.createdByUser?.firstName || "-";
  if (data?.createdByUser?.lastName) {
    name += ` ${data?.createdByUser?.lastName}`;
  }
  return name;
};

export const Permission = (accessKey) => (data) => {
  const permission = data?.scope?.[accessKey];
  return (
    <ul className="edexlms-scope-permission-list">
      <li
        className={`pi pi-eye ${permission.includes("Read") ? "active" : ""}`}
      ></li>
      <li
        className={`pi pi-plus ${
          permission.includes("Create") ? "active" : ""
        }`}
      ></li>
      <li
        className={`pi pi-pencil ${
          permission.includes("Update") ? "active" : ""
        }`}
      ></li>
      <li
        className={`pi pi-trash ${
          permission.includes("Delete") ? "active" : ""
        }`}
      ></li>
    </ul>
  );
};

export const StringData = (key) => (data) => {
  return data[key] || "-";
};

export const OtherActions =
  (actions, notAllowedKey, notAllowedValue) => (data) => {
    return (
      <MoreActions
        actions={actions}
        data={data}
        notAllowedKey={notAllowedKey}
        notAllowedValue={notAllowedValue}
      />
    );
  };

export const LearningStatus = (key) => (data) => {
  const status = data?.[key]?.toLowerCase() ?? "notstarted";
  let color = "var(--orange-500)";
  if (status === "completed") {
    color = "var(--green-500)";
  } else if (status === "overdue") {
    color = "var(--red-500)";
  } else if (
    status === "inprogress" ||
    status === "started" ||
    status === "incomplete"
  ) {
    color = "#0EA5E9";
  }

  return (
    <div
      style={{
        backgroundColor: color,
        color: "white",
        width: "100px",
        textAlign: "center",
        borderRadius: "5px",
        padding: "2px",
      }}
      className="text-sm"
    >
      {customIntl.formatMessage({ id: status }).toUpperCase()}
    </div>
  );
};
